import { Component, Input } from '@angular/core';
import { DocumentsService } from '@lib/services/documents.service';
import { TemplateNamePipe } from 'src/app/pipes/template-name.pipe';

@Component({
  selector: 'app-download-template',
  templateUrl: './download-template.component.html',
  styleUrls: ['./download-template.component.scss'],
})
export class DownloadTemplateComponent {
  @Input({ required: true }) templateName: string;

  isLoading = false;
  private templatePipe: TemplateNamePipe;
  constructor(private documentService: DocumentsService) {
    this.templatePipe = new TemplateNamePipe();
  }

  async onDownload() {
    this.isLoading = true;
    try {
      const templateFile = await this.documentService.getTemplateFile(this.templateName);
      if (templateFile) {
        const transformedTemplateName = this.templatePipe.transform(this.templateName);
        const downloadFileName = `${transformedTemplateName}.${templateFile.fileExtension}`;
        const documentUrl = await this.documentService.fetchAndCacheStorageDocument(templateFile);
        if (documentUrl) {
          this.documentService.downloadDocumentFromUrl(documentUrl, downloadFileName);
        }
      }
    } finally {
      this.isLoading = false;
    }
  }
}
